import { CardSaveActionsComponent } from './card-save-actions/card-save-actions.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureEnabledDirective } from 'src/app/core/directives/feature-enabled.directive';
import { FileDropZoneComponent } from './file-drop-zone/file-drop-zone.component';

import { FileUploadModule } from 'ng2-file-upload';
import { TagInputModule } from 'ngx-chips';
import { CoreModule } from 'src/app/core/core.module';
import { DynamicSelectInputComponent } from './dynamic-select-input/dynamic-select-input.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicInputTagsComponent } from './dynamic-input-tags/dynamic-input-tags.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { DynamicEditorComponent } from './dynamic-editor/dynamic-editor.component';
import { QuillModule } from 'ngx-quill';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicSwitcheryComponent } from './dynamic-switchery/dynamic-switchery.component';
import { DynamicConfirmModalComponent } from './dynamic-confirm-modal/dynamic-confirm-modal.component';
import { DynamicDropZoneComponent } from './dynamic-drop-zone/dynamic-drop-zone.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DynamicInputModalComponent } from './dynamic-input-modal/dynamic-input-modal.component';
import { CustomDropzonePreviewComponent } from './custom-dropzone-preview/custom-dropzone-preview.component';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import { DynamicSwiperComponent } from './dynamic-swiper/dynamic-swiper.component';
import { SwiperDirective } from 'src/app/core/directives/swiper.directive';
import { DynamicPropertyFilterByComponent } from './dynamic-property-filter-by/dynamic-property-filter-by.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavigationMenusConfigComponent } from './navigation-menus-config/navigation-menus-config.component';
import { DynamicLinkConfigComponent } from './dynamic-link-config/dynamic-link-config.component';
import { DynamicDataFilterComponent } from './dynamic-data-filter/dynamic-data-filter.component';
import { DynamicFilterDataDragDropComponent } from './dynamic-filter-data-drag-drop/dynamic-filter-data-drag-drop.component';
import { MultiDragDropComponent } from './multi-drag-drop/multi-drag-drop.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PipeModule } from "../../core/pipes/pipe.module";
import { DynamicTemplateIframeComponent } from './dynamic-template-iframe/dynamic-template-iframe.component';
import { DynamicTextInputModalComponent } from './dynamic-text-input-modal/dynamic-text-input-modal.component';
import { TermsConditionsModalComponent } from './terms-conditions-modal/terms-conditions-modal.component';
import { CurrencyChangeComponent } from './currency-manager/currency-change/currency-change.component';
import { BannerNotificationComponent } from './banner-notification/banner-notification.component';
import { GlobalDashboardSkeletonComponent } from './skeletons/global-dashboard-skeleton/global-dashboard-skeleton.component';
import { SitesGridSkeletonComponent } from './skeletons/sites-grid-skeleton/sites-grid-skeleton.component';
import { TemplateConfigSkeletonComponent } from './skeletons/template-config-skeleton/template-config-skeleton.component';
import { ChooseTemplateSkeletonComponent } from './skeletons/choose-template-skeleton/choose-template-skeleton.component';
import { SiteBuildingStatusModalComponent } from './site-building-status-modal/site-building-status-modal.component';
import { SiteSetupIllustrationComponent } from './site-setup-illustration/site-setup-illustration.component';
import { GlobalDashboardChartSkeletonComponent } from './skeletons/global-dashboard-skeleton/global-dashboard-chart-skeleton/global-dashboard-chart-skeleton.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { ProductDetailsSkeletonComponent } from './skeletons/product-details-skeleton/product-details-skeleton.component';
import { ProductsListSkeletonComponent } from './skeletons/products-list-skeleton/products-list-skeleton.component';
import { OrdersListSkeletonComponent } from './skeletons/orders-list-skeleton/orders-list-skeleton.component';
import { OrderDetailsSkeletonComponent } from './skeletons/order-details-skeleton/order-details-skeleton.component';
import { CategoriesListSkeletonComponent } from './skeletons/categories-list-skeleton/categories-list-skeleton.component';
import { ShopSettingsSkeletonComponent } from './skeletons/shop-settings-skeleton/shop-settings-skeleton.component';
import { DashboardSkeletonComponent } from './skeletons/dashboard-skeleton/dashboard-skeleton.component';
import { NoSitesComponent } from './no-sites/no-sites.component';
import { MobileWarningComponent } from './mobile-warning/mobile-warning.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ContextualSavebarComponent } from './contextual-savebar/contextual-savebar.component';
import { SitePageHeaderComponent } from './site-page-header/site-page-header.component';
import { SectionCardComponent } from './section-card/section-card.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';

import { ImageCropperModule } from 'ngx-image-cropper';

import { DynamicImageCropperModalComponent } from './dynamic-image-cropper-modal/dynamic-image-cropper-modal.component';
import { MultimediaGalleryModalComponent } from './multimedia-gallery-modal/multimedia-gallery-modal.component';
import { MediaLibraryComponent } from './media-library/media-library.component';
import { MediaPickerModalComponent } from './media-picker-modal/media-picker-modal.component';
import { MediaLibrarySkeletonComponent } from './skeletons/media-library-skeleton/media-library-skeleton.component';

// register Swiper custom elements
register();

@NgModule({
  exports: [
    CardSaveActionsComponent,
    FeatureEnabledDirective,
    TranslateModule,
    FileDropZoneComponent,
    DynamicSelectInputComponent,
    NgSelectModule,
    DynamicInputTagsComponent,
    DynamicEditorComponent,
    DynamicSwitcheryComponent,
    DynamicConfirmModalComponent,
    DynamicDropZoneComponent,
    DynamicPropertyFilterByComponent,
    NavigationMenusConfigComponent,
    DynamicLinkConfigComponent,
    DynamicTemplateIframeComponent,
    CurrencyChangeComponent,
    BannerNotificationComponent,
    TermsConditionsModalComponent,
    GlobalDashboardSkeletonComponent,
    SitesGridSkeletonComponent,
    TemplateConfigSkeletonComponent,
    ChooseTemplateSkeletonComponent,
    SiteBuildingStatusModalComponent,
    PipeModule,
    GlobalDashboardChartSkeletonComponent,
    ProductDetailsSkeletonComponent,
    ProductsListSkeletonComponent,
    OrdersListSkeletonComponent,
    OrderDetailsSkeletonComponent,
    CategoriesListSkeletonComponent,
    ShopSettingsSkeletonComponent,
    DashboardSkeletonComponent,
    ChatbotComponent,
    ImageCropperModule,
    MultimediaGalleryModalComponent,
    DragDropModule,
    NoSitesComponent,
    MobileWarningComponent,
    MediaLibraryComponent,
    MediaLibrarySkeletonComponent,
    PageHeaderComponent,
    SitePageHeaderComponent,
    ContextualSavebarComponent,
    SectionCardComponent,
    EmptyStateComponent,

    //DynamicSwiperComponent

  ],
  declarations: [
        FeatureEnabledDirective,
        FileDropZoneComponent,
        DynamicSelectInputComponent,
        DynamicInputTagsComponent,
        DynamicEditorComponent,
        DynamicSwitcheryComponent,
        DynamicConfirmModalComponent,
        DynamicDropZoneComponent,
        DynamicInputModalComponent,
        CustomDropzonePreviewComponent,
        DynamicPropertyFilterByComponent,
        NavigationMenusConfigComponent,
        DynamicLinkConfigComponent,
        DynamicDataFilterComponent,
        DynamicFilterDataDragDropComponent,
        MultiDragDropComponent,
        DynamicTemplateIframeComponent,
        DynamicTextInputModalComponent,
        TermsConditionsModalComponent,
        CurrencyChangeComponent,
        BannerNotificationComponent,
        GlobalDashboardSkeletonComponent,
        SitesGridSkeletonComponent,
        TemplateConfigSkeletonComponent,
        ChooseTemplateSkeletonComponent,
        SiteBuildingStatusModalComponent,
        GlobalDashboardChartSkeletonComponent,
        ProductDetailsSkeletonComponent,
        ProductsListSkeletonComponent,
        OrdersListSkeletonComponent,
        OrderDetailsSkeletonComponent,
        CategoriesListSkeletonComponent,
        ShopSettingsSkeletonComponent,
        DashboardSkeletonComponent,
        ChatbotComponent,
        DynamicImageCropperModalComponent,
        MediaPickerModalComponent,
        MultimediaGalleryModalComponent,
        NoSitesComponent,
        MobileWarningComponent,
        MediaLibraryComponent,
        MediaLibrarySkeletonComponent,
        PageHeaderComponent,
        SitePageHeaderComponent,
        ContextualSavebarComponent,
        SectionCardComponent,
        EmptyStateComponent,

    ],

    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        SiteSetupIllustrationComponent,
    CardSaveActionsComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        FileUploadModule,
        CoreModule,
        TagInputModule,
        UiSwitchModule,
        TranslateModule,
        NgxDropzoneModule,
        QuillModule,
        SwiperDirective,
        DragDropModule,
        NgbModule,
        PipeModule,
        ImageCropperModule
    ]
})
export class SharedModule {

}
